import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import InfoBox, {
  InfoBoxSpacer,
} from '../../../common/EnhancedGridFeature/InfoBox';
import MenuIcon from '../../ACShared/MenuIcon';
import DeleteDefinition from './DeleteDefinition';
// import ShareDefinition from './ShareDefinition';
import EditNameDefinition from './EditNameDefinition';
import DuplicateDefinition from './DuplicateDefinition';
import {
  AC_PERSONAL_FOLDER_SCOPE,
  AC_SHARED_FOLDER_SCOPE,
  AC_GLOBAL_FOLDER_SCOPE,
} from '../../AutocodeConstants';

const DefinitionFolderMenu = ({ item, fill, onEditName, onDelete }) => {
  const infoBoxRef = useRef(null);

  let containerClassName = 'autocode-definition-personal-container';

  const buildInfoBox = () => {
    const content = [];
    if (
      item.scope === AC_PERSONAL_FOLDER_SCOPE.value1 ||
      item.scope === AC_PERSONAL_FOLDER_SCOPE.value2
    ) {
      containerClassName = 'autocode-definition-personal-container';

      content.push(<DuplicateDefinition data={item} infoBoxRef={infoBoxRef} />);
      content.push(<EditNameDefinition onEditName={onEditName} />);
      // content.push(<ShareDefinition onShare={onShare} />)
      content.push(
        <InfoBoxSpacer Height="41px" boxClassName="ibox-spacer-hline" />
      );

      content.push(<DeleteDefinition onDelete={onDelete} />);
    } else if (
      item.scope === AC_SHARED_FOLDER_SCOPE.value1 ||
      item.scope === AC_SHARED_FOLDER_SCOPE.value2
    ) {
      containerClassName = 'autocode-definition-shared-container';

      content.push(<DuplicateDefinition data={item} infoBoxRef={infoBoxRef} />);
      // content.push(
      //   <InfoBoxSpacer Height="17px" boxClassName="ibox-spacer-hline" />
      // );

      // content.push(<DeleteDefinition onDelete={onDelete} />);
    } else if (
      item.scope === AC_GLOBAL_FOLDER_SCOPE.value1 ||
      item.scope === AC_GLOBAL_FOLDER_SCOPE.value2
    ) {
      containerClassName = 'autocode-definition-global-container';

      content.push(<DuplicateDefinition data={item} infoBoxRef={infoBoxRef} />);
    }

    return content;
  };

  return (
    <span data-test="definitionMenuComponent">
      <InfoBox
        ref={infoBoxRef}
        Panels={buildInfoBox()}
        updatePanels={buildInfoBox}
        Positions={['bottom']}
        InfoBoxButtonInner={<MenuIcon fill={fill} />}
        Align="end"
        containerClassName={containerClassName}
      />
    </span>
  );
};

DefinitionFolderMenu.propTypes = {
  item: PropTypes.shape({
    scope: PropTypes.number,
  }),
  fill: PropTypes.string,
  onEditName: PropTypes.func,
  onShare: PropTypes.func,
  onDelete: PropTypes.func,
};

export default DefinitionFolderMenu;
